/* RESPONSIBLE TEAM: team-proactive-support */
import ApplicationAdapter from '../application';

export default ApplicationAdapter.extend({
  pathForType() {
    return 'control_groups';
  },
});
